import { makeAsyncActionCreator } from 'services/store/utils-actions';
import updateRemoteDocument from 'services/store/utils/actions/updateRemoteDocument';
import { collection, types } from 'services/store/todos/definitions';

// NOTE: A `start` change through this action does not sync `views.schedule.blocks`, and the
//       stored view is authoritative — so such an edit would silently not render. All current
//       start-changing paths go through scheduleIntent or the Scheduler's doIntentUpdate,
//       which sync the view themselves; if start edits are ever added to a generic intent
//       form, route them through scheduleIntent or sync the view here. [claude:fable 12.Jul.26]

const updateIntent = makeAsyncActionCreator({
  type: types.UPDATE_TODO,
  creator: async (intent, changes) => {
    const { todo, ...other } = changes;
    const updates = { ...todo };

    if (typeof updates.desc !== 'undefined' && intent.todo.type === 'activity') {
      other.desc = updates.desc;
      delete updates.desc;
    }

    for (const key of Object.keys(other)) {
      updates[`intents.${intent.scheduleId}.${key}`] = other[key];
    }

    return await updateRemoteDocument(collection, intent.todo.id, updates);
  },
  status: {
    path: collection,
    type: 'write',
    parameters: (intent, _changes) => [ intent.id ],
  }
});

export default updateIntent;
